import { track } from "./track";

// Must match the key written by src/components/cookie-consent.tsx.
const CONSENT_STORAGE_KEY = "cd-cookie-consent-v1";
const ATTRIBUTION_COOKIE = "cd_landing_cta";
const THIRTY_DAYS_SECONDS = 30 * 24 * 60 * 60;

/**
 * Analytics consent gate. track() itself does not check consent, so every
 * landing CTA call goes through here. Fires only when the visitor has
 * explicitly accepted analytics cookies ("all"); never on "essential"
 * or before any choice has been stored.
 */
export function hasAnalyticsConsent(): boolean {
  try {
    if (typeof window === "undefined") return false;
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return false;
    return (JSON.parse(raw) as { choice?: string }).choice === "all";
  } catch {
    return false;
  }
}

export function trackLandingCta(cta_placement: string, cta_label: string): void {
  if (typeof window === "undefined") return;
  if (!hasAnalyticsConsent()) return;
  const viewport = window.innerWidth < 1024 ? "mobile" : "desktop";
  track("landing_cta_click", { cta_placement, cta_label, viewport });
  try {
    // First-party signup-attribution cookie; read by the auth flow elsewhere.
    document.cookie = `${ATTRIBUTION_COOKIE}=${encodeURIComponent(
      cta_placement,
    )}; path=/; SameSite=Lax; max-age=${THIRTY_DAYS_SECONDS}`;
  } catch {
    /* Analytics must never break the UI. */
  }
}
